// Bound each attempt as well as the retry count, including stalled connections.
export function fetchQueueRequest(
  url: string,
  options?: RequestInit
): Promise<Response>;
export function fetchQueueRequest<T>(
  url: string,
  options: RequestInit,
  readResponse: (response: Response) => Promise<T>
): Promise<T>;
export async function fetchQueueRequest<T>(
  url: string,
  options: RequestInit = {},
  readResponse?: (response: Response) => Promise<T>
): Promise<Response | T> {
  const controller = new AbortController();
  const abort = () => controller.abort(options.signal?.reason);
  const timeout = setTimeout(
    () =>
      controller.abort(new DOMException('Request timed out', 'TimeoutError')),
    15000
  );
  if (options.signal?.aborted) abort();
  else options.signal?.addEventListener('abort', abort, { once: true });
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });
    return readResponse ? await readResponse(response) : response;
  } finally {
    clearTimeout(timeout);
    options.signal?.removeEventListener('abort', abort);
  }
}
